import { render } from "./rightSidebar.vue?vue&type=template&id=ce3c88b0"
import script from "./rightSidebar.vue?vue&type=script&lang=js"
export * from "./rightSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__